import { Box, Card, CardContent, Stack, Typography } from "@mui/material";
import React from "react";
import GlobalButton from "../../../components/CustomButton";
import appcolors from "../../../constants/Colors";

const AppointmentCard = ({
  service,
  handleRemoveService,
  handleAddService,
}) => {
  return (
    <Stack spacing={2}>
      <Card
        key={service?._id}
        sx={{
          height: "auto",
          width: "100%",
          boxShadow: 0,
          border: 1,
          borderColor: "divider",
        }}
      >
        <CardContent>
          <Stack
            spacing={1}
            flexDirection={"row"}
            justifyContent={"space-between"}
          >
            <Box>
              <Typography
                fontSize={14}
                lineHeight={2}
                sx={{ color: "#000", textDecoration: "underline" }}
              >
                {service.serviceName}
              </Typography>

              <Typography
                variant="body2"
                lineHeight={1}
                sx={{ color: "gray", textDecoration: "underline" }}
              >
                {service.duration}{" "}
                {`${service?.serviceDescription?.slice(0, 60)} ...`}
              </Typography>
              <Typography
                variant="body2"
                mt={1}
                sx={{ color: "gray", textDecoration: "underline" }}
              >
                {service.price} SAR
              </Typography>
            </Box>
            {!service?.isSelected && (
              <Box>
                <GlobalButton
                  variant={"contained"}
                  handleClickBtn={handleAddService}
                  btnText={"Add"}
                  styleProps={{
                    height: 25,
                    width: 80,
                    fontWeight: 400,
                    fontSize: "0.875rem",
                  }}
                />
              </Box>
            )}
            {service?.isSelected && (
              <Box>
                <GlobalButton
                  variant={"contained"}
                  handleClickBtn={handleRemoveService}
                  btnText={"Remove"}
                  styleProps={{
                    height: 25,
                    width: 80,
                    fontWeight: 400,
                    fontSize: "0.875rem",
                    backgroundColor: appcolors.lightGrey,
                    borderColor: appcolors.lightGrey,
                  }}
                />
              </Box>
            )}
          </Stack>
        </CardContent>
      </Card>
    </Stack>
  );
};

export default AppointmentCard;
